import {
  permissionsSelector,
  useClientStore,
} from 'react-scale/components/ExpertManagement/stores/client.store';

import { ITeamLeadPodTypeJson, TeamLeadPermissionRole } from '@scale/shared/types/expertManagement';
import {
  GLOBAL_ROLES,
  POD_SPECIFIC_ROLES,
} from 'react-scale/components/ExpertManagement/constants';
import { shallow } from 'zustand/shallow';

// checks if user has access to any of the required permissions (all permissions are OR'ed)
export const useIsCurrentUserAuthorized = (
  requiredPermissions: TeamLeadPermissionRole[],
  podType?: string,
) => {
  const permissions = useClientStore(permissionsSelector, shallow);

  const roles = permissions?.roles ?? [];

  if (roles.includes(TeamLeadPermissionRole.SuperAdmin)) {
    // SuperAdmin has all permissions
    return true;
  }

  if (GLOBAL_ROLES.some(r => requiredPermissions.includes(r))) {
    if (roles.some(r => requiredPermissions.includes(r))) {
      return true;
    }
  }

  if (POD_SPECIFIC_ROLES.some(r => requiredPermissions.includes(r))) {
    // cannot use pod specific permissions without a pod type
    if (!podType) {
      return false;
    }

    const permissionedIds = (permissions?.permissionedPodTypes ?? []).map(
      p => (p as ITeamLeadPodTypeJson)._id,
    );
    // If the required permission is pod specific, check if the user has the permission for the specific pod
    return (
      permissionedIds?.includes(podType) &&
      (permissions?.roles ?? []).some(r => requiredPermissions.includes(r))
    );
  }

  return false;
};
